<div class="tabs-group">
    <mat-tab-group [animationDuration]="animationDuration"
                   [disableRipple]="disableRipple">
        <mat-tab *ngFor="let tab of tabsContentList">
                <ng-template mat-tab-label class="xxx">
                    <i class="icon {{tab.icon}}"></i>
                    <div class="label" translate>{{ tab.label }}</div>
                </ng-template>
                <ng-container [ngTemplateOutlet]="tab.content"></ng-container>
        </mat-tab>
    </mat-tab-group>
</div>